module.exports = "<h3 class=\"faq-category-{{category.id}}\">{{ category.title }}</h3>\n<ng-container *ngFor=\"let item of category.items\">\n    <div class=\"item\">\n        <h4 class=\"faq-category-item-{{item.id}} faq-category-item-rank{{item.rank}}\" [innerHTML]=\"item.question | safeHtml\" id=\"item-{{item.id}}\"></h4>\n        <div [innerHTML]=\"item.answer | safeHtml\"></div> \n    </div>\n        \n    <div class=\"category-item-seperator\"></div>\n</ng-container>\n"


//////////////////
// WEBPACK FOOTER
// ./src/main/webapp/app/faq/faq-category/faq-category.component.html
// module id = 797
// module chunks = 0